<!-- 创建时间2023/06/20 09:20:05 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：下载权限 -->
<template>
  <div>
    <yxt-checkbox v-model="allowDownload_" :true-label="1" :false-label="0" :disabled="disabled">
      {{ $t('pc_kng_permissionset_lbl_candownload'/** 允许下载 */) }}
      <span v-if="allowDownload_">{{ $t('pc_kng_upload_label_candownload_desc'/** （控制PC端、App端是否允许下载） */) }}</span>
    </yxt-checkbox>
    <div v-if="allowDownload_">
      <yxt-radio-group class="ml24" v-model="permissionType" direction="row" :disabled="disabled">
        <yxt-radio :label="0">{{ $t('pc_kng_lbl_classification_down'/** 跟随分类中的“允许下载课件”权限 */) }}</yxt-radio>
        <yxt-radio :label="1">{{ $t('pc_kng_upload_lbl_down_allow'/** 单独设置允许下载 */) }}</yxt-radio>
      </yxt-radio-group>
      <auth-selector
        v-if="permissionType === 1"
        class="mt10 ml24"
        :permissions="permissions"
        :disabled="disabled"
        dataPermissionCode="kjgl_Download_permission_selection_range"
        @update="update"
      />
    </div>
  </div>
</template>

<script>
import authSelector from './auth-selector.vue';
export default {
  name: 'form-download-auth',
  components: {
    authSelector
  },
  props: {
    allowDownload: {
      // 是否允许下载
      type: Number,
      default: undefined
    },
    value: {
      // 权限类型 跟随目录 or 单独设置
      type: Number,
      default: 0
    },
    permissions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    allowDownload_: {
      get() {
        return this.allowDownload;
      },
      set(val) {
        this.$emit('update:allowDownload', val);
      }
    },
    permissionType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  created() {
    if (this.allowDownload === undefined) {
      this.allowDownload_ = 1;
    }
  },
  methods: {
    update(val) {
      this.$emit('update:permissions', val);
    }
  }
};
</script>